export default __webpack_public_path__ + "static/media/select-arrow.ba7006ba.svg";